// 中国学历等级数据
export interface DegreeOption {
  value: string;
  label: string;
}

export const chinaDegrees: DegreeOption[] = [
  { value: "小学", label: "小学" },
  { value: "初中", label: "初中" },
  { value: "高中", label: "高中" },
  { value: "中专", label: "中专" },
  { value: "职高", label: "职高" },
  { value: "大专", label: "大专" },
  { value: "本科", label: "本科" },
  { value: "硕士", label: "硕士" },
  { value: "博士", label: "博士" },
  { value: "博士后", label: "博士后" },
  { value: "其他", label: "其他" },
];

// 根据值获取标签
export const getDegreeLabel = (value: string): string => {
  const degree = chinaDegrees.find(d => d.value === value);
  return degree ? degree.label : value;
};

// 根据标签获取值
export const getDegreeValue = (label: string): string => {
  const degree = chinaDegrees.find(d => d.label === label);
  return degree ? degree.value : label;
};